import React from 'react'

import { Space, Select, Divider } from 'antd'

import { useCacheManager, getManagersForSelect } from '../../../../hooks/cache/manager'
import { useCacheClient, getProjectsForSelect, getPointsOfSaleForSelect } from '../../../../hooks/cache/client'
import { useCacheService, getServicesForSelect } from '../../../../hooks/cache/service'
import { useCacheVendor, getVendorsForSelect } from '../../../../hooks/cache/vendor'

const Filters = (props) => {
  const { filters } = props
  const { data: servicesRaw } = useCacheService()
  const { data: clientsRaw } = useCacheClient()
  const { data: vendorsRaw } = useCacheVendor()
  const { data: managersRaw } = useCacheManager()

  const manager = filters ? (filters.manager ? parseInt(filters.manager) : undefined) : undefined
  const project = filters ? (filters.project ? parseInt(filters.project) : undefined) : undefined
  const pointOfSale = filters ? (filters.pointOfSale ? parseInt(filters.pointOfSale) : undefined) : undefined
  const vendor = filters ? (filters.vendor ? parseInt(filters.vendor) : undefined) : undefined
  const service = filters ? (filters.service ? parseInt(filters.service) : undefined) : undefined

  const _filter = (input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0

  if (props.loading) {
    return null
  }

  const managers = getManagersForSelect(managersRaw)
  const services = getServicesForSelect(servicesRaw)
  const projects = getProjectsForSelect(clientsRaw)
  const pointOfSales = getPointsOfSaleForSelect(clientsRaw)
  const vendors = getVendorsForSelect(vendorsRaw)

  return (
    <Space size='small'>
      <Select
        placeholder='Manager'
        allowClear
        size='small'
        showSearch
        options={managers}
        filterOption={_filter}
        style={{ minWidth: '150px' }}
        value={manager}
        onChange={(e) => {
          props.onUpdateFilters({ manager: e ? e : undefined })
        }}
      />
      <Divider type='vertical ' />
      <Select
        placeholder='Service'
        allowClear
        size='small'
        showSearch
        options={services}
        filterOption={_filter}
        style={{ minWidth: '150px' }}
        value={service}
        onChange={(e) => {
          props.onUpdateFilters({ service: e ? e : undefined })
        }}
      />
      <Divider type='vertical ' />
      <Select
        placeholder='Project'
        allowClear
        size='small'
        showSearch
        options={projects}
        filterOption={_filter}
        style={{ minWidth: '150px' }}
        value={project}
        onChange={(e) => {
          props.onUpdateFilters({ project: e ? e : undefined })
        }}
      />
      <Divider type='vertical ' />
      <Select
        placeholder='Point Of Sale'
        allowClear
        size='small'
        showSearch
        options={pointOfSales}
        filterOption={_filter}
        style={{ minWidth: '150px' }}
        value={pointOfSale}
        onChange={(e) => {
          props.onUpdateFilters({ pointOfSale: e ? e : undefined })
        }}
      />
      <Divider type='vertical ' />
      <Select
        placeholder='Vendor'
        allowClear
        size='small'
        showSearch
        options={vendors}
        filterOption={_filter}
        style={{ minWidth: '150px' }}
        value={vendor}
        onChange={(e) => {
          props.onUpdateFilters({ vendor: e ? e : undefined })
        }}
      />
    </Space>
  )
}

export default Filters